import { Remote } from '@/api/remote';
import Swiper from 'swiper';
import { UiConstants } from '@/constants/ui_constants';
import { Constants } from '@/constants/constants';
import { Util } from '@/utils/utils';
import { ApiConstant } from '@/constants/api_constants';

let commonHeaderBannerSwiper: any = null;
let isAddGnbWrapEvent = false;
let gnbDelayTimer: number | null = null;

const UiCommon = {
	/**
	 * 알럿창 호출
	 * @param title
	 * @param message
	 * @param buttonTitle
	 * @param callback
	 */
	showLayerAlert(
		title: string,
		message: string,
		buttonTitle: string = UiConstants.label.confirm,
		callback: (() => void) | null = null
	) {
		const alertId = 'alertLayer';
		let customMessage = Constants.empty;

		message.split('<br>').forEach(msg => {
			customMessage += `<p>${msg}</p>`;
		});

		document.body.insertAdjacentHTML(
			'afterbegin',
			`
			<div class="modal inmodal" id="${alertId}" tabindex="-1" role="dialog"  aria-hidden="true">
				<div class="modal-dialog alert">
					<div class="modal-content animated fadeIn">
						<div class="modal-body">
							<strong class="title">${title}</strong>
							${customMessage}
						</div>
						<div class="modal-footer">
							<button type="button" class="btn primary">${buttonTitle}</button>
						</div>
					</div>
				</div>
			</div>
      `
		);

		const button = document.querySelector(`#${alertId} .btn.primary`) as HTMLButtonElement;

		button.onclick = () => {
			const alertElement = document.getElementById(alertId);
			if (alertElement) {
				alertElement.remove();
			}
			if (callback) callback();
		};
	},

	/**
	 * 컨펌창 호출
	 * @param title
	 * @param message
	 * @param confirmButtonTitle
	 * @param cancelButtonTitle
	 * @param confirmCallback
	 * @param cancelCallback
	 */
	showLayerConfirm(
		title: string,
		message: string,
		confirmButtonTitle: string = UiConstants.label.confirm,
		cancelButtonTitle: string = UiConstants.label.cancel,
		confirmCallback: (() => void) | null = null,
		cancelCallback: (() => void) | null = null
	) {
		const confirmId = 'confirmLayer';

		const customTitle = title
			.split('<br>')
			.map(msg => `<span>${msg}</span>`)
			.join('');
		const customMessage = message
			.split('<br>')
			.map(msg => `<span>${msg}</span>`)
			.join('');

		// 컨펌창 추가
		document.body.insertAdjacentHTML(
			'afterbegin',
			`
      <div class="modal inmodal" id="${confirmId}" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog alert">
          <div class="modal-content animated fadeIn">
            <div class="modal-body">
              <strong class="title">${customTitle}</strong>
              ${customMessage}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn primary" id="confirmButton">${confirmButtonTitle}</button>
              <button type="button" class="btn red outline" id="cancelButton">${cancelButtonTitle}</button>
            </div>
          </div>
        </div>
      </div>
      `
		);

		const confirmModal = document.getElementById(confirmId) as HTMLElement;

		// 확인 버튼 이벤트
		const confirmButton = confirmModal.querySelector('#confirmButton') as HTMLButtonElement;
		confirmButton.addEventListener('click', () => {
			confirmModal.remove();
			if (confirmCallback) confirmCallback();
		});

		// 취소 버튼 이벤트
		const cancelButton = confirmModal.querySelector('#cancelButton') as HTMLButtonElement;
		cancelButton.addEventListener('click', () => {
			confirmModal.remove();
			if (cancelCallback) cancelCallback();
		});

		// 모달 표시
		confirmModal.style.display = 'block';
		document.body.classList.add('modal-open');
	},

	// 상단 띠배너 닫기버튼 클릭
	clickCloseHeaderBanner() {
		Util.setCookie('header_banner', 'close', 1);
		commonHeaderBannerSwiper?.autoplay?.stop();
		document.querySelector('header')?.classList.remove('has-banner');
	},

	// 셀렉트 박스 생성
	addSelectBox() {
		const selectWraps = document.querySelectorAll('.select-wrap');
		selectWraps.forEach((selectWrap, index) => {
			selectWrap.addEventListener('click', () => {
				const selectList = document.querySelectorAll('.select-list')[index];
				if (selectList) {
					selectList.classList.toggle('visible');
				}
			});
		});

		document.addEventListener('click', event => {
			if (!(event.target as HTMLElement).closest('.select-wrap')) {
				document.querySelectorAll('.select-list').forEach(list => list.classList.remove('visible'));
			}
		});
	},

	async setHeaderBanner() {
		const params = { pcOrMo: 'pc' };
		const response = await Remote.Api.get(`${ApiConstant.mgmtHomeBnnr.list}`, params);

		if (response.code !== Constants.apiSuccess) {
			alert(response.message);
			document.body.classList.remove('is-visible');
			return;
		}

		if (response.content.length > 0) {
			let htmlContent = '';
			response.content.forEach((list: any) => {
				const linkTarget = list.urlRedirectType === 'URLRDTP001' ? '_blank' : '_self';
				// TODO: dev 에서 homeBnnrPcImg 키가 없음
				// TODO: homeBnnrLinkUrl 리액트 버전과 맞추어 변경 필요
				htmlContent += `
          <div class="swiper-slide">
            <a href="${list.homeBnnrLinkUrl}" target="${linkTarget}">${list.homeBnnrPcImg || ''}</a>
          </div>`;
			});

			const bannerWrapper = document.querySelector('.header-banner .swiper-wrapper');
			if (bannerWrapper) bannerWrapper.innerHTML = htmlContent;

			this.addSwiper();
			this.checkHeaderBanner();
		} else {
			document.body.classList.remove('is-visible');
		}
	},

	checkHeaderBanner() {
		const isShowBanner = Util.isNullOrEmpty(Util.getCookie('header_banner'));
		if (isShowBanner) {
			document.querySelector('header')?.classList.add('has-banner');
			const swiperContainer = document.querySelector('.header-banner .swiper-container');
			if (swiperContainer) {
				swiperContainer.addEventListener('mouseover', this.onOverHeaderBanner);
				swiperContainer.addEventListener('mouseout', this.onOutHeaderBanner);
			}
		} else {
			commonHeaderBannerSwiper?.autoplay?.stop();
		}
		document.body.classList.remove('is-visible');
	},

	onOverHeaderBanner() {
		commonHeaderBannerSwiper?.autoplay?.stop();
	},

	onOutHeaderBanner() {
		commonHeaderBannerSwiper?.autoplay?.start();
	},

	headerScroll() {
		window.addEventListener('scroll', () => {
			const header = document.querySelector('.header');
			if (!header) return;

			const windowY = window.scrollY;
			if (windowY > 10) {
				header.classList.add('scroll');
			} else {
				header.classList.remove('scroll');
			}
		});
	},

	checkPopupBanner() {
		const isShowBanner = Util.isNullOrEmpty(Util.getCookie('popup_banner'));
		if (isShowBanner) {
			this.showPopupBanner();
		}
	},

	popupBannerClickDontSee(e: Event) {
		Util.setCookie('popup_banner', 'close', 1);
		this.hidePopupBanner();
	},

	popupBannerClickClose(e: Event) {
		this.hidePopupBanner();
	},

	showPopupBanner() {
		document.body.classList.add('modal-open');
		const modal = document.querySelector('.modal.inmodal') as HTMLElement | null;
		if (modal) {
			modal.style.display = 'block';
		}
	},

	hidePopupBanner() {
		document.body.classList.remove('modal-open');
		const modal = document.querySelector('.modal.inmodal') as HTMLElement | null;
		if (modal) {
			modal.style.display = 'none';
		}
	},

	addSwiper() {
		const swiperContainer = document.querySelector('.header-banner .swiper-container') as HTMLElement | null;

		if (swiperContainer) {
			commonHeaderBannerSwiper = new Swiper(swiperContainer, {
				loop: true,
				direction: 'vertical',
				autoplay: {
					delay: 3000
				}
			});
		} else {
			console.warn('Swiper container not found: .header-banner .swiper-container');
		}
	},

	addEvent() {
		document.querySelectorAll('.gnb .depth1').forEach(menu => {
			menu.addEventListener('mouseover', this.onOverDepth1.bind(this));
			menu.addEventListener('mouseout', this.onOutDepth1.bind(this));
		});

		document.querySelectorAll('.gnb .depth1 > a').forEach(menu => {
			menu.addEventListener('mouseover', this.onOverDepth1Menu.bind(this));
		});
	},

	onOverGnb() {
		this.showSubMenu();
	},

	onOutGnb() {
		this.hideSubMenu();
	},

	showSubMenu() {
		this.stopGnbDelayTimer();
		const header = document.querySelector('.header');
		if (header) {
			header.classList.add('is-over');
		}
	},

	hideSubMenu() {
		this.startGnbDelayTimer();
		const header = document.querySelector('.header');
		if (header) {
			header.classList.remove('is-over');
		}
	},

	onOverDepth1(e: Event) {
		const target = e.currentTarget as HTMLElement;
		const children = target.querySelector('ul');
		if (children) {
			target.classList.add('current-list');
		}
	},

	onOutDepth1(e: Event) {
		const target = e.currentTarget as HTMLElement;
		const children = target.querySelector('ul');
		if (children) {
			target.classList.remove('current-list');
		}
	},

	onOverDepth1Menu(e: Event) {
		if (!isAddGnbWrapEvent) {
			isAddGnbWrapEvent = true;

			const gnbWrap = document.querySelector('.gnb-wrap') as HTMLElement | null;

			if (gnbWrap) {
				gnbWrap.addEventListener('mouseover', this.onOverGnb.bind(this));
				gnbWrap.addEventListener('mouseout', this.onOutGnb.bind(this));
			}
		}
	},

	startGnbDelayTimer() {
		this.stopGnbDelayTimer(); // 기존 타이머 정리
		gnbDelayTimer = window.setInterval(() => {
			this.gnbDelayTimerHandler();
		}, 500);
	},

	stopGnbDelayTimer() {
		if (gnbDelayTimer !== null) {
			clearInterval(gnbDelayTimer);
			gnbDelayTimer = null;
		}
	},

	gnbDelayTimerHandler() {
		if (isAddGnbWrapEvent) {
			this.stopGnbDelayTimer();
			isAddGnbWrapEvent = false;

			const gnbWrap = document.querySelector('.gnb-wrap') as HTMLElement | null;

			if (gnbWrap) {
				gnbWrap.removeEventListener('mouseover', this.onOverGnb.bind(this));
				gnbWrap.removeEventListener('mouseout', this.onOutGnb.bind(this));
			}
		}
	},

	getStellaUrl() {
		const isDevMode = location.hostname === 'localhost' || location.hostname.includes('dev');
		const isStgMode = location.hostname.includes('stg');
		return `https://${isDevMode ? 'dev' : isStgMode ? 'stg' : 'www'}.stella-erp.com`;
	},

	goStellaService(subUrl = Constants.empty) {
		const url = UiCommon.getStellaUrl() + subUrl;
		window.open(url, '_blank');
	}
};

export { UiCommon };
